@if (isOpen()) {
  <div class="flex flex-col overflow-hidden assistant-widget-panel" (keydown.escape)="close()">
    <div class="flex items-center gap-2 justify-between assistant-widget-header">
      <div class="custom-subtitle" translate>SSP.ASSISTANT.TITLE</div>
      <ui-button variant="outlined" [rounded]="true" icon="far fa-times" (clicked)="close()" />
    </div>

    <div #messageContainer class="flex flex-col gap-2 overflow-y-auto p-2 flex-1">
      @if (messages().length === 0) {
        <p>{{ 'SSP.ASSISTANT.EMPTY' | translate }}</p>
        <div class="flex flex-col pl-4">
          @for (message of emptyExampleMessages; track message) {
            <div class="flex items-center gap-2">
              <i class="fas fa-circle fa-xs"></i>
              <span (click)="sendExampleMessage(message)" class="cursor-pointer hover:text-primary">{{ message }}</span>
            </div>
          }
        </div>
      }
      @for (item of messages(); track item.id) {
        <div class="assistant-widget-message" [class.assistant-widget-message-user]="item.role === 'user'">
          <strong>{{ item.role === 'user' ? ('SSP.ASSISTANT.YOU' | translate) : ('SSP.ASSISTANT.ASSISTANT' | translate) }}</strong>
          @if (item.text) {
            <markdown class="assistant-widget-markdown" [data]="item.text"></markdown>
          }
          @if (item.status) {
            <p>
              <i class="far fa-spinner fa-spin"></i>
              {{ 'SSP.ASSISTANT.STATUS.' + item.status | translate }}
            </p>
          }
          @if (item.error) {
            <p>{{ 'SSP.ASSISTANT.ERRORS.' + item.error | translate }}</p>
          }
        </div>
      }
    </div>

    <div class="flex items-center gap-2 p-2 assistant-widget-compose">
      <textarea pTextarea [(ngModel)]="message" name="message" rows="1" [autoResize]="true" (keydown.enter)="onEnter($event)" fluid></textarea>
      @if (sending()) {
        <ui-button icon="fas fa-stop" severity="danger" [rounded]="true" (clicked)="stopMessage()"></ui-button>
      }
      <ui-button [disabled]="sending() || !message.trim()" [rounded]="true" severity="success" icon="far fa-paper-plane" (clicked)="sendMessage()"></ui-button>
    </div>
  </div>
}

<ui-button class="assistant-widget-toggle" [rounded]="true" severity="primary" size="large" [icon]="isOpen() ? 'far fa-times' : 'far fa-message-bot'" (clicked)="toggle()" />
